module.exports = __webpack_public_path__ + "img/LogoDashboard-19.5ef48dea.svg";